import { useAppSelector } from '@customer/store/hooks';
import { setMaxDistance } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MeasurementUnit } from '@customer/store/apis/authApi';
import NumberFilter from './NumberFilter';
import { ReactElement } from 'react';

export const MaxDistanceFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicInputElement>): ReactElement => {
  const { t } = useTranslation();
  const units = useAppSelector(state => state.auth.units);

  return (
    <NumberFilter
      filterName="maxDistance"
      label={
        label ??
        t('DistanceLessThan', {
          unit: t(units === MeasurementUnit.Metric ? 'unit.metre_other' : 'unit.feet_other'),
        })
      }
      tooltipLabel={t('Distance between assets')}
      elementRef={elementRef}
      action={setMaxDistance}
    />
  );
};

export default MaxDistanceFilter;
